import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import useStyles from './expertiseStyle';
import useTitle from '../Title/titleStyle';
import { useText } from '../../theme/common';

function Expertise() {
  // Theme breakpoints
  const { classes: text } = useText();
  const { classes, cx } = useStyles();
  const { classes: title } = useTitle();

  return (
    <>
      <div className={classes.root}>
        <Container>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column" // Ustawienie elementów w jednej kolumnie
            spacing={2} // Opcjonalne: odstępy między elementami
          >
            <Grid item>
              <Typography className={cx(title.default, text.subtitle)} variant="h4">
                Certyfikat zarządzania jakością ISO
              </Typography>
            </Grid>
            <Grid item>
              <img
                src="/images/certyfikat.png"
                alt="Certyfikat zarządzania jakością ISO"
                style={{
                  display: 'block',
                  margin: '40px auto 0',
                  maxWidth: '50%',
                  height: 'auto',
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
}

export default Expertise;